import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend) // public 폴더에서 번역 파일을 불러옵니다.
  .use(LanguageDetector) // 사용자의 언어를 감지합니다.
  .use(initReactI18next) // i18n 인스턴스를 react-i18next에 전달합니다.
  .init({
    fallbackLng: 'en', // 번역 파일이 없을 경우 기본 언어
    debug: true, // 개발 중 디버그 메시지를 콘솔에 출력합니다.
    interpolation: {
      escapeValue: false, // React는 이미 XSS 방어 기능이 있으므로 false로 설정합니다.
    },
    // 언어 감지기 옵션
    detection: {
      order: ['localStorage', 'navigator'], // 감지 순서: localStorage -> 브라우저 언어
      caches: ['localStorage'], // 감지된 언어를 저장할 위치
      lookupLocalStorage: 'insightwin-language', // localStorage에서 언어를 찾을 때 사용할 키
    },
  });

export default i18n; 